import React from "react";
import Modal from "react-responsive-modal";

class Quizreport extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
      isToggleOpen: false,
      value: 0,
      allQuiz: []
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.open !== prevProps.open) {
      var quiz_arr = JSON.parse(localStorage.getItem("quiz"));
      this.setState({ allQuiz: JSON.parse(localStorage.getItem("quiz")) });
      console.log(localStorage.getItem("quiz"));
      var total_score = 0;
      var obtained_score = 0;
      if (quiz_arr) {
        for (var i = 0; i < quiz_arr.length; i++) {
          obtained_score = obtained_score + quiz_arr[i].obtained_score;
          total_score = total_score + quiz_arr[i].total_score;
        }
        this.setState({
          obtained_score: obtained_score,
          total_score: total_score,
          score: quiz_arr.length * 5
        });
      }
    }
  }

  render() {
    const { open } = this.props;
    return (
      <Modal open={open} onClose={this.props.close} classNames={"report"}>
        <div className="border-0 card card-style-3  py-3 row text-center report-model new-quiz">
          <div className="container">
            <h3 className="mb-3 text-primary">{this.props.name}</h3>
            <hr />
            {this.state.allQuiz ? (
              <div className="row mb-3">
                <div className="bg-red-gradient d-flex flex-column justify-content-center align-item-center bg-white col col-md-3 m-2 p-2 rounded shadow-lg text-bold">
                  <span>Points</span>
                  <span>+{this.state.score}</span>
                </div>
                <div className="bg-black-gradient d-flex flex-column justify-content-center align-item-center bg-white col col-md-5 py-3 rounded shadow-lg text-bold">
                  <span>Accuracy</span>
                  <span>
                    {(
                      (100 * this.state.obtained_score) /
                      this.state.total_score
                    ).toFixed(2)}
                    %
                  </span>
                </div>
                <div className="bg-white d-flex flex-column justify-content-center align-item-center bg-yellow-gradient col m-2 p-2 py-3 rounded shadow-lg text-bold">
                  <span>Score</span>
                  <span>
                    {this.state.obtained_score}/{this.state.total_score}
                  </span>
                </div>
              </div>
            ) : (
              <div className="mx-auto text-center mb-3">
                <b>You not played any quiz.</b>
              </div>
            )}
            <div className="font-secondary row">
              <table className="table">
                <tr className="text-bold">
                  <td className="m-1 p-1">Questions</td>
                  <td className="m-1 p-1">Attempts</td>
                  <td className="m-1 p-1">Time</td>
                  <td className="m-1 p-1">Score</td>
                  <td className="m-1 p-1">Points</td>
                </tr>
                {this.state.allQuiz
                  ? this.state.allQuiz.map((op, index) => (
                      <tr className="text-bold text-1">
                        <td className="m-1 p-1">Q{index + 1}</td>
                        {op.obtained_score == op.total_score ? (
                          <td className="m-1 p-1">
                            {" "}
                            <i className="far text-bold p-1 fa-smile text-success" />
                            X {op.no_of_attempted}{" "}
                          </td>
                        ) : (
                          <td className="m-1 p-1">
                            {" "}
                            <i className="far text-bold p-1 fa-frown text-danger" />
                            X {op.no_of_attempted}{" "}
                          </td>
                        )}
                        <td className="m-1 p-1">{op.time_spent_duration}s</td>
                        <td className="m-1 p-1">{op.obtained_score}</td>
                        <td className="m-1 p-1">+ {op.total_point}</td>
                      </tr>
                    ))
                  : ""}
              </table>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default Quizreport;
